import authRules from '../authRules';

const mySchedule = (user) => {
  const { mySchedule } = user.securityLevels;
  if (mySchedule >= authRules.mySchedule.mySchedule) {
      return true;
  } else {
      return false;
    }
  }

export default mySchedule;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/mySchedule.js